import cn from '@/lib/cs';
import React from 'react';

const CalendarIcon = ({ className, ...props }: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        aria-hidden
        className={cn('h-8 lg:h-12 pointer-events-none', className)}
        {...props}
    >
        <path
            className="transition-all"
            fill="currentColor"
            d="M24 21.2c-.3-3.2-1.2-6.2-.3-9.5-1.3-1.8.3-4 .2-6-.7-1 .2-2.3-.3-3.3-1-1.2-3 .8-4-.2 0-.6-.3-1.1-1-1-2.2 1.1 1 1.2-3.8 1.2-.5-.2 0-1.3-1-1.4-.4 0-1.3.6-1.2 1.2-.8 0-1.5.2-2.4.1.2-1 0-.9-.8-1-1.1-.1-1 .7-1.6 1-3.3.1-4.2.5-3.7 4-.4 2.4-.3 5.3-.9 7.7-.8 1.4-1.7 3-3 4-1.2 2.6 3 1.4 4 2 0 .8 0 2.4 1.3 2.2 2.6-.8 19.3 1.6 18.4-1ZM5.2 17c-.8-.2-1.5.4-2.3.4.3-.7 1.1-1.3 1.2-2.2 0-.7.4-1.3.8-1.9.4-.6 1.4-1.2.8-2 0-.5.3-1 0-1.6 0-.4-.4-.9-.3-1.2.1 0 .2-.3.4-.3h2.8c1.6-.3 1.6-.8 2.7-.6 2.4.3 1.1.3 2.5.4.7 0 1.6-.5 2.3-.2 1 1 2 .7 3.2 1 1 .1 1.8-.8 2.6-.3.2.4 0 1 .2 1.4.2 1-.3 1.8-.5 2.8 0 .8-.6 1.5-1 2.2-.3.5-1 .7-1.3 1-1.6 2-1.5 1-3.5 1.7-1.5.7-3.2-.3-4.8-.3-2-.2-4 .8-5.8-.3Zm17.2 2-.4 1c-.5.6-1.6.4-2.3.4-1.3.2-2 .6-3.4.2-1.6-.4-3.3 0-4.9 0-1-.3-2 0-3-.2l-2.7.2c-.2-.2 0-.6-.2-.8.2-.2.7 0 1 0 .3 0 .6 0 1-.2.6-.3 1.4 0 2.1 0 .5 0 1-.3 1.4-.2.2 0 .5.3.7.1.8-.4 1.8.2 2.6.2.7 0 1.5-.3 2.2-.4.8 0 1.7.3 2.4 0 1-.7 1.6-.5 1.6-1.8.3-.8 1.5-1 1.6-2 .2 1 0 2 .3 3v.5Z"
        />
    </svg>
);

export default CalendarIcon;
